import { render, staticRenderFns } from "./client-group-data.vue?vue&type=template&id=d624d110&"
import script from "./client-group-data.vue?vue&type=script&lang=ts&"
export * from "./client-group-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports